export const TOGGLE_PHONE = 'TOGGLE_PHONE';

export function togglePhone(show = null) {
    return {
        type: TOGGLE_PHONE,
        show: show
    }
}